import React, { useState, useEffect } from 'react';
import { Dropdown } from 'semantic-ui-react'
import { GetCommonBaseURL } from '../axiosComponent/readAxios';
const MyIndustry = ({
    field: { name },
    form: { setFieldValue },
    ...props
}) => {
    const [content, setcontent] = useState([])
    const [loading, setloading] = useState(false)
    useEffect(() => {
        setloading(true)
        GetCommonBaseURL({
            newUrl: 'masters/industry_segment',
            response: ((data) => {
                let cont = data.data.resultSet
                setcontent(cont)
                setloading(false)
            })
        })
    }, [])
    let options = []
    if (content.length > 0) {
        content.map((object, index) => {
            let temp = {}
            temp.key = object.industrySegmentCode
            temp.text = `${object.industrySegmentName}`
            temp.value = object.industrySegmentId
            return options[index] = temp
        })
    }
    let handleChange = (value, data) => {
        setFieldValue(name, data.value)
    }
    return (
        <Dropdown
            selection
            loading={loading ? true : false}
            style={{ width: '100%' }}
            onChange={handleChange}
            options={options}
            noResultsMessage="Search for Result"
            {...props}
        />

    )
}

export default MyIndustry